import { render, staticRenderFns } from "./smsTariffPicker.vue?vue&type=template&id=1d2eeb6a&scoped=true"
import script from "./smsTariffPicker.vue?vue&type=script&lang=js"
export * from "./smsTariffPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2eeb6a",
  null
  
)

export default component.exports